import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import jobsApiService from "../services/jobsApiService";
import masterApi from "../../../services/master.api";
import greenCheck from "../../../assets/green-check.png";
import viewIcon from "../../../assets/view-icon.png";
import deleteIcon from "../../../assets/delete-icon.png";
import { toast } from "react-toastify";

import { handleEyeClick } from "../../../shared/utils/fileDownload";

const QualificationFamilyDetails = ({
  applicationId,
  formData,
  setFormData,
  handleChange,
  errors,
  handleQualificationChange,
  handleCertificationChange,
  handleFamilyChange,
  handleGratuityChange,
  addCertificate,
  removeCertificate,
  addFamily,
  removeFamily,
  addNominee,
  removeNominee,
}) => {
  const [certMasterOptions, setCertMasterOptions] = useState([]);

  useEffect(() => {
    const fetchMasters = async () => {
      try {
        const res = await masterApi.getCertifications();
        // Handle all possible response structures
        let certificates = [];

        if (Array.isArray(res)) {
          certificates = res;
        } else if (Array.isArray(res?.data)) {
          certificates = res.data;
        } else if (Array.isArray(res?.data?.data)) {
          certificates = res.data.data;
        }

        const options = certificates.map((item) => ({
          value: item.certificationMasterId,
          label: item.certificationName,
        }));

        setCertMasterOptions(options);
      } catch (err) {
        console.error("Certificate API Error:", err);
        setCertMasterOptions([]);
      }
    };

    fetchMasters();
  }, []);

  const relationshipOptions = [
    "Father",
    "Mother",
    "Husband",
    "Wife",
    "Son",
    "Daughter",
    "Brother",
    "Sister",
    "Grandfather",
    "Grandmother",
    "Father-in-law",
    "Mother-in-law",
    "Son-in-law",
    "Daughter-in-law",
    "Brother-in-law",
    "Sister-in-law",
    "Legal Guardian",
  ];

  return (
    <>
      {formData?.qualificationDetails?.map((qualification, index) => (
        <div
          key={index}
          className="px-4 pb-4 rounded row g-4 formfields bg-white border shadow-sm mb-5"
        >
          <div className="section-header">
            <span className="section-header-title">
              Qualification Details - {qualification.qualificationLevel}
            </span>
          </div>

          {/* Course Name */}
          <div className="col-lg-3 col-md-6">
            <label className="form-label">
              Name of the Course
              <span className="text-danger">*</span>
            </label>

            <select
              disabled
              className={`form-select onboarding-input ${
                errors?.[index]?.courseName ? "is-invalid" : ""
              }`}
              value={qualification.courseName || ""}
            >
              <option value={qualification.courseName}>
                {qualification.courseName || "Select Course"}
              </option>
            </select>

            {errors?.[index]?.courseName && (
              <small className="text-danger">{errors[index].courseName}</small>
            )}
          </div>

          {/* School */}
          <div className="col-lg-3 col-md-6">
            <label className="form-label">
              Name of the School / Institution
              <span className="text-danger">*</span>
            </label>

            <input
              type="text"
              disabled
              className={`form-control onboarding-input ${
                errors?.[index]?.schoolInstitution ? "is-invalid" : ""
              }`}
              value={qualification.schoolInstitution || ""}
            />

            {errors?.[index]?.schoolInstitution && (
              <small className="text-danger">
                {errors[index].schoolInstitution}
              </small>
            )}
          </div>

          {/* Specialization */}
          {/* Specialization */}
          {!(
            qualification.courseName?.includes("SSC") ||
            qualification.courseName?.includes("10th") ||
            qualification.courseName?.includes("CBSE") ||
            qualification.courseName?.includes("ICSE")
          ) && (
            <div className="col-lg-3 col-md-6">
              <label className="form-label">Specialization</label>

              <input
                type="text"
                disabled={!qualification.isSpecializationEditable}
                className={`form-control onboarding-input ${
                  errors?.[index]?.specializationName ? "is-invalid" : ""
                }`}
                value={qualification.specializationName || ""}
                onChange={(e) =>
                  handleQualificationChange(
                    index,
                    "specializationName",
                    e.target.value,
                  )
                }
              />

              {errors?.[index]?.specializationName && (
                <small className="text-danger">
                  {errors[index].specializationName}
                </small>
              )}
            </div>
          )}

          <div className="col-lg-3 col-md-6">
            <label className="form-label">
              {qualification.courseName?.includes("SSC") ||
              qualification.courseName?.includes("10th") ||
              qualification.courseName?.includes("CBSE") ||
              qualification.courseName?.includes("ICSE") ||
              qualification.courseName?.includes("Intermediate") ||
              qualification.courseName?.includes("12th") ||
              qualification.courseName?.includes("HSC") ||
              qualification.courseName?.includes("Intermediate Board") ||
              qualification.courseName?.includes("CBSE (+2)") ||
              qualification.courseName?.includes("ICSE (+2)") ? (
                <>Board</>
              ) : (
                <>Name of University</>
              )}
            </label>

            <input
              type="text"
              disabled
              placeholder={
                qualification.courseName?.includes("SSC") ||
                qualification.courseName?.includes("10th") ||
                qualification.courseName?.includes("CBSE") ||
                qualification.courseName?.includes("ICSE") ||
                qualification.courseName?.includes("Intermediate") ||
                qualification.courseName?.includes("12th") ||
                qualification.courseName?.includes("HSC") ||
                qualification.courseName?.includes("Intermediate Board") ||
                qualification.courseName?.includes("CBSE (+2)") ||
                qualification.courseName?.includes("ICSE (+2)")
                  ? ""
                  : ""
              }
              // disabled={
              //   qualification.courseName?.includes("SSC") ||
              //   qualification.courseName?.includes("10th") ||
              //   qualification.courseName?.includes("CBSE") ||
              //   qualification.courseName?.includes("ICSE") ||
              //   qualification.courseName?.includes("Intermediate") ||
              //   qualification.courseName?.includes("12th") ||
              //   qualification.courseName?.includes("HSC") ||
              //   qualification.courseName?.includes("Intermediate Board") ||
              //   qualification.courseName?.includes("CBSE (+2)") ||
              //   qualification.courseName?.includes("ICSE (+2)")
              // }
              className={`form-control onboarding-input ${
                errors?.[index]?.universityName ? "is-invalid" : ""
              }`}
              value={
                qualification.courseName?.includes("SSC") ||
                qualification.courseName?.includes("10th") ||
                qualification.courseName?.includes("CBSE") ||
                qualification.courseName?.includes("ICSE") ||
                qualification.courseName?.includes("Intermediate") ||
                qualification.courseName?.includes("12th") ||
                qualification.courseName?.includes("HSC") ||
                qualification.courseName?.includes("Intermediate Board") ||
                qualification.courseName?.includes("CBSE (+2)") ||
                qualification.courseName?.includes("ICSE (+2)")
                  ? qualification.courseName || ""
                  : qualification.universityName || ""
              }
              onChange={(e) =>
                handleQualificationChange(
                  index,
                  "universityName",
                  e.target.value,
                )
              }
            />

            {errors?.[index]?.universityName && (
              <small className="text-danger">
                {errors[index].universityName}
              </small>
            )}
          </div>

          {/* Percentage */}
          <div className="col-lg-3 col-md-6">
            <label className="form-label">
              Percentage of Marks (%)
              <span className="text-danger">*</span>
            </label>

            <input
              type="number"
              disabled
              className={`form-control onboarding-input ${
                errors?.[index]?.percentageMarks ? "is-invalid" : ""
              }`}
              value={qualification.percentageMarks || ""}
            />

            {errors?.[index]?.percentageMarks && (
              <small className="text-danger">
                {errors[index].percentageMarks}
              </small>
            )}
          </div>

          {/* Date of Passing */}
          <div className="col-lg-3 col-md-6">
            <label className="form-label">
              Date of Passing
              <span className="text-danger">*</span>
            </label>

            <input
              type="date"
              disabled
              className={`form-control onboarding-input ${
                errors?.[index]?.dateOfPassing ? "is-invalid" : ""
              }`}
              value={qualification.dateOfPassing || ""}
            />

            {errors?.[index]?.dateOfPassing && (
              <small className="text-danger">
                {errors[index].dateOfPassing}
              </small>
            )}
          </div>

          {/* Division */}
          <div className="col-lg-3 col-md-6">
            <label className="form-label">
              Division
              <span className="text-danger">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter division"
              className={`form-control onboarding-input ${
                errors?.qualificationDetails?.[index]?.division
                  ? "is-invalid"
                  : ""
              }`}
              value={qualification.division || ""}
              onChange={(e) =>
                handleQualificationChange(index, "division", e.target.value)
              }
            />

            {errors?.qualificationDetails?.[index]?.division && (
              <small className="text-danger">
                {errors?.qualificationDetails?.[index]?.division}
              </small>
            )}
          </div>

          {/* Nature Of Course */}
          <div className="col-lg-3 col-md-6">
            <label className="form-label">
              Education Type
              <span className="text-danger">*</span>
            </label>

            <select
              disabled
              className={`form-select onboarding-input ${
                errors?.[index]?.natureOfCourse ? "is-invalid" : ""
              }`}
              value={qualification.natureOfCourse || ""}
            >
              <option value={qualification.natureOfCourse}>
                {qualification.natureOfCourse || "Select Nature Of Course"}
              </option>
            </select>

            {errors?.[index]?.natureOfCourse && (
              <small className="text-danger">
                {errors[index].natureOfCourse}
              </small>
            )}
          </div>
        </div>
      ))}

      <div className="px-4 pb-4 rounded bg-white border shadow-sm mb-5">
        <div style={{ marginTop: "22px" }}></div>
        <div className="section-header" style={{ marginBottom: "20px" }}>
          <span className="section-header-title">Certification Details</span>
        </div>

        {/* Certification Details */}

        {formData?.certificationDetails?.map((certification, index) => {
          const isCandidateCertificate = !!certification.candidateCertificateId;

          const selectedOption = certMasterOptions.find(
            (option) =>
              String(option.value) ===
              String(certification.certificationMasterId),
          );

          return (
            <div
              key={index}
              className="px-4 pb-4 rounded border shadow-sm mb-4"
            >
              {/* <p
                    className="tab_headers"
                    style={{ marginBottom: "0px", marginTop: "1rem" }}
                >
                    Certification Details
                </p> */}
              <div style={{ marginTop: "22px" }}></div>
              <h6 className="fw-bold mb-3" style={{ color: "#42579f" }}>
                Certification Details {index + 1}
              </h6>
              <div className="row g-4">
                <div className="col-lg-3 col-md-6">
                  <label className="form-label">
                    Name of the Certification
                    {(certification.certificationMasterId ||
                      certification.certificationName) && (
                      <span className="text-danger">*</span>
                    )}
                  </label>

                  <Select
                    classNamePrefix="react-select"
                    className={
                      errors?.certificationDetails?.[index]?.certificationName
                        ? "is-invalid"
                        : ""
                    }
                    placeholder="Select Certification"
                    options={certMasterOptions}
                    isDisabled={isCandidateCertificate}
                    value={
                      certMasterOptions.find(
                        (option) =>
                          String(option.value) ===
                          String(certification.certificationMasterId),
                      ) ||
                      certMasterOptions.find(
                        (option) =>
                          option.label?.trim().toLowerCase() ===
                          certification.certificationName?.trim().toLowerCase(),
                      ) ||
                      null
                    }
                    onChange={(selected) => {
                      handleCertificationChange(
                        index,
                        "certificationMasterId",
                        selected?.value || "",
                      );

                      handleCertificationChange(
                        index,
                        "certificationName",
                        selected?.label || "",
                      );

                      if (selected?.label !== "Other") {
                        handleCertificationChange(
                          index,
                          "otherCertificationName",
                          "",
                        );
                      }

                      // Clear custom certification name when changing from Other
                      if (selected?.label !== "Other") {
                        handleCertificationChange(
                          index,
                          "otherCertificationName",
                          "",
                        );
                      }
                    }}
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        borderColor: errors?.certificationDetails?.[index]
                          ?.certificationName
                          ? "#dc3545"
                          : provided.borderColor,
                        boxShadow: errors?.certificationDetails?.[index]
                          ?.certificationName
                          ? "0 0 0 0.2rem rgba(220,53,69,.25)"
                          : provided.boxShadow,
                        "&:hover": {
                          borderColor: errors?.certificationDetails?.[index]
                            ?.certificationName
                            ? "#dc3545"
                            : provided.borderColor,
                        },
                      }),
                    }}
                  />

                  {errors?.certificationDetails?.[index]?.certificationName && (
                    <small className="text-danger">
                      {errors.certificationDetails[index].certificationName}
                    </small>
                  )}
                </div>

                {(certification.certificationName === "Other" ||
                  certMasterOptions.find(
                    (x) =>
                      String(x.value) ===
                      String(certification.certificationMasterId),
                  )?.label === "Other") && (
                  <div className="col-lg-3 col-md-6">
                    <label className="form-label">
                      Certification Name
                      <span className="text-danger">*</span>
                    </label>

                    <input
                      type="text"
                      placeholder="Enter Certification Name"
                      className={`form-control onboarding-input ${
                        errors?.certificationDetails?.[index]
                          ?.otherCertificationName
                          ? "is-invalid"
                          : ""
                      }`}
                      value={
                        certification.otherCertificationName ||
                        (certification.certificationName !== "Other"
                          ? ""
                          : certification.certificationDisplayName || "")
                      }
                      onChange={(e) =>
                        handleCertificationChange(
                          index,
                          "otherCertificationName",
                          e.target.value,
                        )
                      }
                    />

                    {errors?.certificationDetails?.[index]
                      ?.otherCertificationName && (
                      <small className="text-danger">
                        {
                          errors.certificationDetails[index]
                            .otherCertificationName
                        }
                      </small>
                    )}
                  </div>
                )}

                <div className="col-lg-3 col-md-6">
                  <label className="form-label">
                    Name of the Institution
                    {(certification.certificationMasterId ||
                      certification.certificationName) && (
                      <span className="text-danger">*</span>
                    )}
                  </label>
                  {/* <label className="form-label">Name of the Institution<span className="text-danger">*</span></label> */}
                  <input
                    type="text"
                    disabled={isCandidateCertificate}
                    placeholder="Enter name of the institution"
                    className={`form-control onboarding-input ${
                      errors?.certificationDetails?.[index]?.institutionName
                        ? "is-invalid"
                        : ""
                    }`}
                    value={certification.institutionName || ""}
                    onChange={(e) =>
                      handleCertificationChange(
                        index,
                        "institutionName",
                        e.target.value,
                      )
                    }
                  />

                  {errors?.certificationDetails?.[index]?.institutionName && (
                    <small className="text-danger">
                      {errors.certificationDetails[index].institutionName}
                    </small>
                  )}
                </div>

                <div className="col-lg-3 col-md-6">
                  <label className="form-label">
                    Date of Passing
                    {(certification.certificationMasterId ||
                      certification.certificationName) && (
                      <span className="text-danger">*</span>
                    )}
                  </label>
                  {/* <label className="form-label">Date of Passing<span className="text-danger">*</span></label> */}
                  <input
                    type="date"
                    disabled={isCandidateCertificate}
                    className={`form-control onboarding-input ${
                      errors?.certificationDetails?.[index]
                        ?.certificationDateOfPassing
                        ? "is-invalid"
                        : ""
                    }`}
                    value={certification.certificationDateOfPassing || ""}
                    onChange={(e) =>
                      handleCertificationChange(
                        index,
                        "certificationDateOfPassing",
                        e.target.value,
                      )
                    }
                  />

                  {errors?.certificationDetails?.[index]
                    ?.certificationDateOfPassing && (
                    <small className="text-danger">
                      {
                        errors.certificationDetails[index]
                          .certificationDateOfPassing
                      }
                    </small>
                  )}
                </div>

                <div className="col-lg-3 col-md-6">
                  <label className="form-label">
                    Percentage of Marks (%)
                    {(certification.certificationMasterId ||
                      certification.certificationName) && (
                      <span className="text-danger">*</span>
                    )}
                  </label>
                  {/* <label className="form-label">Percentage of Marks (%)<span className="text-danger">*</span></label> */}
                  <input
                    type="number"
                    min="0"
                    max="100"
                    placeholder="Enter percentage of marks"
                    className={`form-control onboarding-input ${
                      errors?.certificationDetails?.[index]
                        ?.certificationPercentage
                        ? "is-invalid"
                        : ""
                    }`}
                    value={certification.certificationPercentage || ""}
                    onChange={(e) => {
                      let value = e.target.value;

                      if (Number(value) > 100) {
                        value = 100;
                      }

                      handleCertificationChange(
                        index,
                        "certificationPercentage",
                        value,
                      );
                    }}
                  />

                  {errors?.certificationDetails?.[index]
                    ?.certificationPercentage && (
                    <small className="text-danger">
                      {
                        errors?.certificationDetails?.[index]
                          ?.certificationPercentage
                      }
                    </small>
                  )}
                </div>

                <div className="col-lg-3 col-md-6">
                  <label className="form-label">
                    Upload Your Documents
                    {(certification.certificationMasterId ||
                      certification.certificationName) && (
                      <span className="text-danger">*</span>
                    )}
                  </label>

                  {!certification.fileUrl ? (
                    <div
                      className={`border rounded d-flex flex-column align-items-center justify-content-center upload-box ${
                        errors?.certificationDetails?.[index]?.uploadDocument
                          ? "border-danger"
                          : ""
                      }`}
                      style={{
                        minHeight: "100px",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        document
                          .getElementById(`uploadDocumentInput-${index}`)
                          .click()
                      }
                    >
                      <FontAwesomeIcon
                        icon={faUpload}
                        className="text-secondary"
                      />

                      <div
                        className="mt-2"
                        style={{
                          color: "#7b7b7b",
                          fontWeight: "500",
                        }}
                      >
                        Click to upload
                      </div>

                      <div className="text-muted" style={{ fontSize: "12px" }}>
                        PDF, JPG or PNG (Max 2MB)
                      </div>

                      <input
                        id={`uploadDocumentInput-${index}`}
                        type="file"
                        accept=".jpg,.jpeg,.png,.pdf"
                        style={{ display: "none" }}
                        onChange={async (e) => {
                          const file = e.target.files?.[0];
                          if (!file) return;

                          // File type validation
                          const allowedTypes = [
                            "image/jpeg",
                            "image/jpg",
                            "image/png",
                            "application/pdf",
                          ];

                          if (!allowedTypes.includes(file.type)) {
                            toast.error(
                              "Only JPG, JPEG, PNG and PDF files are allowed",
                            );
                            e.target.value = "";
                            return;
                          }

                          // File size validation (Max 2 MB)
                          if (file.size > 2 * 1024 * 1024) {
                            toast.error("File size should not exceed 2 MB");
                            e.target.value = "";
                            return;
                          }

                          try {
                            const response =
                              await jobsApiService.uploadQualificationFile(
                                applicationId,
                                "QUALIFICATION_CERTIFICATE",
                                file,
                              );

                            const uploaded = response.data;

                            const updated = [...formData.certificationDetails];

                            updated[index] = {
                              ...updated[index],
                              uploadDocument: file,

                              // API returns documentName, not displayName
                              displayName: uploaded.documentName || file.name,

                              // API returns documentUrl, not fileUrl
                              fileUrl: uploaded.documentUrl,

                              preOnboardingCandDocId: uploaded.id,

                              // API returns id, not documentId
                              documentId: uploaded.id,

                              isNew: true,
                            };

                            setFormData((prev) => ({
                              ...prev,
                              certificationDetails: updated,
                            }));

                            handleCertificationChange(
                              index,
                              "uploadDocument",
                              file,
                            );
                          } catch (err) {
                            console.error(err);
                          }
                        }}
                      />
                    </div>
                  ) : (
                    <div
                      className="uploaded-file-box p-3 d-flex justify-content-between align-items-center"
                      style={{
                        border: "2px solid #bfc8e2",
                        borderRadius: "8px",
                        background: "#f7f9fc",
                      }}
                    >
                      <div className="d-flex align-items-center">
                        <img
                          src={greenCheck}
                          alt="check"
                          style={{
                            width: "22px",
                            height: "22px",
                            marginRight: "10px",
                          }}
                        />

                        <div>
                          <div
                            style={{
                              fontWeight: 600,
                              color: "#42579f",
                            }}
                          >
                            {certification.displayName}
                          </div>
                        </div>
                      </div>

                      <div className="d-flex gap-2">
                        <img
                          src={viewIcon}
                          alt="View"
                          style={{
                            width: "25px",
                            cursor: "pointer",
                          }}
                          onClick={() => handleEyeClick(certification.fileUrl)}
                        />

                        {certification.isCandidateRemove &&
                          certification.preOnboardingCandDocId && (
                            <img
                              src={deleteIcon}
                              alt="Delete"
                              style={{
                                width: "22px",
                                cursor: "pointer",
                              }}
                              onClick={async () => {
                                try {
                                  await jobsApiService.deleteQualificationFile(
                                    certification.preOnboardingCandDocId,
                                  );

                                  const updated = [
                                    ...formData.certificationDetails,
                                  ];

                                  updated[index] = {
                                    ...updated[index],
                                    uploadDocument: null,
                                    displayName: "",
                                    fileUrl: "",
                                    documentId: null,
                                    preOnboardingCandDocId: null,
                                    isNew: false,
                                  };

                                  setFormData((prev) => ({
                                    ...prev,
                                    certificationDetails: updated,
                                  }));
                                } catch (err) {
                                  console.error("Delete failed", err);
                                }
                              }}
                            />
                          )}
                      </div>
                    </div>
                  )}

                  {errors?.certificationDetails?.[index]?.uploadDocument && (
                    <small className="text-danger d-block mt-1">
                      {errors.certificationDetails[index].uploadDocument}
                    </small>
                  )}
                </div>
                <div className="col-12 mt-3">
                  <div className="d-flex justify-content-end gap-2">
                    {certification.isAdded && (
                      <button
                        type="button"
                        className="btn btn-danger px-4"
                        onClick={() => removeCertificate(index)}
                      >
                        Remove
                      </button>
                    )}

                    {index === formData.certificationDetails.length - 1 && (
                      <button
                        type="button"
                        className="btn text-white px-4"
                        style={{
                          background: "#f26623",
                          borderColor: "#f26623",
                        }}
                        onClick={addCertificate}
                      >
                        + Add Certificate
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Family Details */}
      {/* Family Details */}

      <div className="px-4 pb-4 rounded bg-white border shadow-sm mb-5">
        <div style={{ marginTop: "22px" }}></div>

        <div className="section-header" style={{ marginBottom: "20px" }}>
          <span className="section-header-title">Family Details</span>
        </div>
        {formData?.preOnboardingFamilyDetails?.map((family, index) => (
          <div key={index} className="px-4 pb-4 rounded border shadow-sm mb-4">
            <div style={{ marginTop: "22px" }}></div>

            <h6 className="fw-bold mb-3" style={{ color: "#42579f" }}>
              Family Details {index + 1}
            </h6>

            <div className="row g-4">
              <div className="col-lg-3 col-md-6">
                <label className="form-label">
                  Full Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control onboarding-input ${
                    errors?.preOnboardingFamilyDetails?.[index]?.fullName
                      ? "is-invalid"
                      : ""
                  }`}
                  name="fullName"
                  value={family.fullName || ""}
                  onChange={(e) => handleFamilyChange(index, e)}
                />

                {errors?.preOnboardingFamilyDetails?.[index]?.fullName && (
                  <small className="text-danger">
                    {errors.preOnboardingFamilyDetails[index].fullName}
                  </small>
                )}
              </div>

              <div className="col-lg-3 col-md-6">
                <label className="form-label">
                  Relationship <span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select onboarding-input ${
                    errors?.preOnboardingFamilyDetails?.[index]?.relationship
                      ? "is-invalid"
                      : ""
                  }`}
                  name="relationship"
                  value={family.relationship || ""}
                  onChange={(e) => handleFamilyChange(index, e)}
                >
                  <option value="">Select Relationship</option>

                  {relationshipOptions.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>

                {errors?.preOnboardingFamilyDetails?.[index]?.relationship && (
                  <small className="text-danger">
                    {errors.preOnboardingFamilyDetails[index].relationship}
                  </small>
                )}
              </div>

              <div className="col-lg-3 col-md-6">
                <label className="form-label">
                  Date of Birth <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  className={`form-control onboarding-input ${
                    errors?.preOnboardingFamilyDetails?.[index]?.dateOfBirth
                      ? "is-invalid"
                      : ""
                  }`}
                  name="dateOfBirth"
                  value={family.dateOfBirth || ""}
                  onChange={(e) => handleFamilyChange(index, e)}
                  max={new Date().toISOString().split("T")[0]}
                />

                {errors?.preOnboardingFamilyDetails?.[index]?.dateOfBirth && (
                  <small className="text-danger">
                    {errors.preOnboardingFamilyDetails[index].dateOfBirth}
                  </small>
                )}
              </div>

              <div className="col-lg-3 col-md-6">
                <label className="form-label">
                  Nationality <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control onboarding-input ${
                    errors?.preOnboardingFamilyDetails?.[index]?.nationality
                      ? "is-invalid"
                      : ""
                  }`}
                  name="nationality"
                  value={family.nationality || ""}
                  onChange={(e) =>
                    handleFamilyChange(index, {
                      target: {
                        name: "nationality",
                        value: e.target.value.replace(/[^A-Za-z\s]/g, ""),
                      },
                    })
                  }
                />

                {errors?.preOnboardingFamilyDetails?.[index]?.nationality && (
                  <small className="text-danger">
                    {errors.preOnboardingFamilyDetails[index].nationality}
                  </small>
                )}
              </div>

              <div className="col-lg-3 col-md-6">
                <label className="form-label">
                  Dependent <span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select onboarding-input ${
                    errors?.preOnboardingFamilyDetails?.[index]?.dependent
                      ? "is-invalid"
                      : ""
                  }`}
                  name="dependent"
                  value={family.dependent || ""}
                  onChange={(e) => handleFamilyChange(index, e)}
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>

                {errors?.preOnboardingFamilyDetails?.[index]?.dependent && (
                  <small className="text-danger">
                    {errors.preOnboardingFamilyDetails[index].dependent}
                  </small>
                )}
              </div>

              <div className="col-lg-3 col-md-6">
                <label className="form-label">
                  Person With Benchmark Disability
                  <span className="text-danger">*</span>
                </label>
                <select
                  className={`form-select onboarding-input ${
                    errors?.preOnboardingFamilyDetails?.[index]
                      ?.benchmarkDisability
                      ? "is-invalid"
                      : ""
                  }`}
                  name="benchmarkDisability"
                  value={family.benchmarkDisability || ""}
                  onChange={(e) => handleFamilyChange(index, e)}
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>

                {errors?.preOnboardingFamilyDetails?.[index]
                  ?.benchmarkDisability && (
                  <small className="text-danger">
                    {
                      errors.preOnboardingFamilyDetails[index]
                        .benchmarkDisability
                    }
                  </small>
                )}
              </div>

              <div className="col-lg-3 col-md-6">
                <label className="form-label">
                  Occupation <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control onboarding-input ${
                    errors?.preOnboardingFamilyDetails?.[index]?.occupation
                      ? "is-invalid"
                      : ""
                  }`}
                  name="occupation"
                  value={family.occupation || ""}
                  onChange={(e) =>
                    handleFamilyChange(index, {
                      target: {
                        name: "occupation",
                        value: e.target.value.replace(/[^A-Za-z\s.-]/g, ""),
                      },
                    })
                  }
                />

                {errors?.preOnboardingFamilyDetails?.[index]?.occupation && (
                  <small className="text-danger">
                    {errors.preOnboardingFamilyDetails[index].occupation}
                  </small>
                )}
              </div>

              <div className="col-lg-3 col-md-6">
                <label className="form-label">
                  Annual Income <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  min="0"
                  className={`form-control onboarding-input ${
                    errors?.preOnboardingFamilyDetails?.[index]?.annualIncome
                      ? "is-invalid"
                      : ""
                  }`}
                  name="annualIncome"
                  value={family.annualIncome || ""}
                  onChange={(e) => handleFamilyChange(index, e)}
                />

                {errors?.preOnboardingFamilyDetails?.[index]?.annualIncome && (
                  <small className="text-danger">
                    {errors.preOnboardingFamilyDetails[index].annualIncome}
                  </small>
                )}
              </div>

              <div className="col-lg-3 col-md-6">
                <label className="form-label">
                  Mobile Number <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  maxLength={10}
                  className={`form-control onboarding-input ${
                    errors?.preOnboardingFamilyDetails?.[index]?.mobileNumber
                      ? "is-invalid"
                      : ""
                  }`}
                  name="mobileNumber"
                  value={family.mobileNumber || ""}
                  onChange={(e) =>
                    handleFamilyChange(index, {
                      target: {
                        name: "mobileNumber",
                        value: e.target.value.replace(/[^0-9]/g, ""),
                      },
                    })
                  }
                />

                {errors?.preOnboardingFamilyDetails?.[index]?.mobileNumber && (
                  <small className="text-danger">
                    {errors.preOnboardingFamilyDetails[index].mobileNumber}
                  </small>
                )}
              </div>

              <div className="col-12 mt-3">
                <div className="d-flex justify-content-end gap-2">
                  {family.isAdded && (
                    <button
                      type="button"
                      className="btn btn-danger px-4"
                      onClick={() => removeFamily(index)}
                    >
                      Remove
                    </button>
                  )}

                  {index === formData.preOnboardingFamilyDetails.length - 1 && (
                    <button
                      type="button"
                      className="btn text-white px-4"
                      style={{
                        background: "#f26623",
                        borderColor: "#f26623",
                      }}
                      onClick={addFamily}
                    >
                      + Add Family
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Gratuity Nomination Details */}
      {/* Gratuity Nomination Details */}

      <div className="px-4 pb-4 rounded bg-white border shadow-sm mb-5">
        <div style={{ marginTop: "22px" }}></div>

        <div className="section-header" style={{ marginBottom: "20px" }}>
          <span className="section-header-title">
            Gratuity Nomination Details
          </span>
        </div>
        {formData?.preOnboardingGratuityNomination?.map((nominee, index) => (
          <div key={index} className="px-4 pb-4 rounded border shadow-sm mb-4">
            <div style={{ marginTop: "22px" }}></div>

            <h6 className="fw-bold mb-3" style={{ color: "#42579f" }}>
              Gratuity Nomination Details {index + 1}
            </h6>

            <div className="row g-4">
              {/* Nominee Name */}
              <div className="col-lg-3 col-md-6">
                <label className="form-label">
                  Name of Nominee <span className="text-danger">*</span>
                </label>

                <input
                  type="text"
                  placeholder="Enter Nominee Name"
                  className={`form-control ${
                    errors?.preOnboardingGratuityNomination?.[index]
                      ?.nomineeName
                      ? "is-invalid"
                      : ""
                  }`}
                  name="nomineeName"
                  value={nominee.nomineeName || ""}
                  onChange={(e) =>
                    handleGratuityChange(index, {
                      target: {
                        name: "nomineeName",
                        value: e.target.value.replace(/[^A-Za-z.\s]/g, ""),
                      },
                    })
                  }
                />

                {errors?.preOnboardingGratuityNomination?.[index]
                  ?.nomineeName && (
                  <small className="text-danger">
                    {errors.preOnboardingGratuityNomination[index].nomineeName}
                  </small>
                )}
              </div>

              {/* Relationship */}
              <div className="col-lg-3 col-md-6">
                <label className="form-label">
                  Nominee Relationship <span className="text-danger">*</span>
                </label>
                <Select
                  classNamePrefix="react-select"
                  placeholder="Select Relationship"
                  menuPlacement="auto"
                  menuPosition="fixed"
                  menuPortalTarget={document.body}
                  maxMenuHeight={250}
                  isSearchable
                  options={relationshipOptions.map((item) => ({
                    value: item,
                    label: item,
                  }))}
                  value={
                    relationshipOptions
                      .map((item) => ({
                        value: item,
                        label: item,
                      }))
                      .find(
                        (option) =>
                          option.value === nominee.nomineeRelationship,
                      ) || null
                  }
                  onChange={(selected) =>
                    handleGratuityChange(index, {
                      target: {
                        name: "nomineeRelationship",
                        value: selected?.value || "",
                      },
                    })
                  }
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      minHeight: "38px",
                      borderColor: state.isFocused ? "#f26623" : "#ced4da",
                      boxShadow: state.isFocused
                        ? "0 0 0 0.2rem rgba(242,102,35,.25)"
                        : "none",
                      "&:hover": {
                        borderColor: "#f26623",
                      },
                    }),

                    menuPortal: (provided) => ({
                      ...provided,
                      zIndex: 9999,
                    }),

                    menu: (provided) => ({
                      ...provided,
                      zIndex: 9999,
                    }),

                    menuList: (provided) => ({
                      ...provided,
                      maxHeight: 250,
                    }),

                    option: (provided, state) => ({
                      ...provided,
                      backgroundColor: state.isSelected
                        ? "#f26623"
                        : state.isFocused
                          ? "#fff2eb"
                          : "#fff",
                      color: state.isSelected ? "#fff" : "#212529",
                      cursor: "pointer",
                    }),

                    placeholder: (provided) => ({
                      ...provided,
                      color: "#6c757d",
                    }),

                    singleValue: (provided) => ({
                      ...provided,
                      color: "#212529",
                    }),
                  }}
                />

                {errors?.preOnboardingGratuityNomination?.[index]
                  ?.nomineeRelationship && (
                  <small className="text-danger">
                    {
                      errors.preOnboardingGratuityNomination[index]
                        .nomineeRelationship
                    }
                  </small>
                )}
              </div>

              {/* Age */}
              <div className="col-lg-3 col-md-6">
                <label className="form-label">
                  Age of Nominee <span className="text-danger">*</span>
                </label>

                <input
                  type="number"
                  min="1"
                  max="120"
                  placeholder="Enter Age"
                  className={`form-control ${
                    errors?.preOnboardingGratuityNomination?.[index]?.nomineeAge
                      ? "is-invalid"
                      : ""
                  }`}
                  name="nomineeAge"
                  value={nominee.nomineeAge || ""}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (
                      value === "" ||
                      (Number(value) >= 1 && Number(value) <= 120)
                    ) {
                      handleGratuityChange(index, e);
                    }
                  }}
                />

                {errors?.preOnboardingGratuityNomination?.[index]
                  ?.nomineeAge && (
                  <small className="text-danger">
                    {errors.preOnboardingGratuityNomination[index].nomineeAge}
                  </small>
                )}
              </div>

              {/* Address */}
              <div className="col-lg-3 col-md-6">
                <label className="form-label">
                  Address of Nominee <span className="text-danger">*</span>
                </label>

                <textarea
                  rows="1"
                  placeholder="Enter Nominee Address"
                  className={`form-control ${
                    errors?.preOnboardingGratuityNomination?.[index]
                      ?.nomineeAddress
                      ? "is-invalid"
                      : ""
                  }`}
                  name="nomineeAddress"
                  value={nominee.nomineeAddress || ""}
                  onChange={(e) => handleGratuityChange(index, e)}
                />

                {errors?.preOnboardingGratuityNomination?.[index]
                  ?.nomineeAddress && (
                  <small className="text-danger">
                    {
                      errors.preOnboardingGratuityNomination[index]
                        .nomineeAddress
                    }
                  </small>
                )}
              </div>

              {/* Share */}
              <div className="col-lg-3 col-md-6">
                <label className="form-label">
                  Amount of Share (%) <span className="text-danger">*</span>
                </label>

                <input
                  type="number"
                  min="1"
                  max="100"
                  placeholder="Enter Share Percentage"
                  className={`form-control ${
                    errors?.preOnboardingGratuityNomination?.[index]
                      ?.amountOfShare
                      ? "is-invalid"
                      : ""
                  }`}
                  name="amountOfShare"
                  value={nominee.amountOfShare || ""}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (
                      value === "" ||
                      (Number(value) >= 1 && Number(value) <= 100)
                    ) {
                      handleGratuityChange(index, e);
                    }
                  }}
                />

                {errors?.preOnboardingGratuityNomination?.[index]
                  ?.amountOfShare && (
                  <small className="text-danger">
                    {
                      errors.preOnboardingGratuityNomination[index]
                        .amountOfShare
                    }
                  </small>
                )}
              </div>

              {errors?.preOnboardingGratuityNomination?.totalShare && (
                <div className="text-danger mb-3">
                  {errors.preOnboardingGratuityNomination.totalShare}
                </div>
              )}

              {/* Add / Remove Buttons */}
              <div className="col-12 mt-3">
                <div className="d-flex justify-content-end gap-2">
                  {nominee.isAdded && (
                    <button
                      type="button"
                      className="btn btn-danger px-4"
                      onClick={() => removeNominee(index)}
                    >
                      Remove
                    </button>
                  )}

                  {index ===
                    formData.preOnboardingGratuityNomination.length - 1 && (
                    <button
                      type="button"
                      className="btn text-white px-4"
                      style={{
                        background: "#f26623",
                        borderColor: "#f26623",
                      }}
                      onClick={addNominee}
                    >
                      + Add Nominee
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default QualificationFamilyDetails;
